<div class="download-app-wrapper">
  <h3>{{ 'dowload-app.download' | translate }}</h3>
  <div class="app-download-btns">
    <a href="https://apps.apple.com/es/app/apanymantel/id1593167805" target="_blank" alt="Descargate la App de Apanymantel para iOS"><img src="/assets/download_apple.webp" alt="Descarga para Iphone" /></a>
    <a href="https://play.google.com/store/apps/details?id=com.apanymantel.app" target="_blank" alt="Descargate la App de Apanymantel para Android"><img src="/assets/download-google.webp" alt="Descarga para Android" /></a>
  </div>
  <button mat-icon-button color="primary" (click)="dismiss()"><i class="fas fa-times"></i></button>
</div>
